function log(a) {
  // eslint-disable-next-line no-console
  console.log(a);

  return a;
}

export default log;
